var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-root"},[_c('div',{staticClass:"page-wrap",class:[_vm.wrapClass ? _vm.wrapClass : '', _vm.isFullPage ? 'page-full' : '']},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }